var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-full space-y-4 px-4 py-8 sm:px-6 lg:px-8"})
}
var staticRenderFns = []

export { render, staticRenderFns }